<template>
  <div class="admin-banner">
    <img :src="mobileadminBanner" alt="" />
    <div class="absolute">
      <div class="title">数字家园管理系统</div>
      <div class="text">
        数字家园管理，以数“治”家，创新科技应用，软件硬件一体化，赋能物业，打通线上线下，助力物业智能化，构建社区生活新生态，实现智慧家园。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/mobile/components/Experience.vue";

import mobileadminBanner from "../../../../assets/product/mobileadminBanner.png";

export default {
  setup() {
    return reactive({
      mobileadminBanner: mobileadminBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.admin-banner {
  position: relative;
}
.admin-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff;
}
.absolute .text {
  font-size: 12px;
  margin-top: 12px;
  color: #fff;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 18px;
  color: #fff;
  border: 1px solid rgba(255,255,255, .8);
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
